import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ spacing }) => ({
  сontainer: {
    backgroundColor: blueGrey[50],
    padding: spacing(3, 6),
    ".MuiBreadcrumbs-separator": {
      margin: spacing(0, 1),
      color: blueGrey[500]
    },
    ol: {
      "li:first-of-type": {
        marginRight: spacing(1)
      }
    },
    nav: {
      lineHeight: 1.25
    }
  },
  link: {
    ":hover": {
      textDecoration: "none",
      color: lightBlue[500],
      cursor: "pointer"
    }
  },
  disabledLink: {
    color: blueGrey[800],
    cursor: "unset"
  }
}))
